import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpen, ChevronRight } from 'lucide-react';
import { supabase } from '@/lib/supabase';
import { useCourse } from '@/hooks/useCourse';
import { useTelegram } from '@/hooks/useTelegram';

/**
 * «Путь со Славой — пройден» в Статистике.
 *
 * Сюда карточка переезжает с главной после первого показа (решение Славы
 * 03.09.2026): на главной она была памятником над кольцом калорий. Здесь
 * у неё две работы — вернуть себя на главную галочкой, если человеку так
 * дороже, и открыть все 21 день для перечитывания.
 */
export function CourseDoneCard() {
  const nav = useNavigate();
  const { haptic } = useTelegram();
  const { progress, loading, reload } = useCourse();
  const [saving, setSaving] = useState(false);

  if (loading || !progress?.completed_at) return null;

  async function toggleHome() {
    if (!progress) return;
    haptic('light');
    setSaving(true);
    const next = !progress.show_on_home;
    await supabase
      .from('user_course_progress')
      .update({ show_on_home: next })
      .eq('user_id', progress.user_id);
    await reload();
    setSaving(false);
  }

  return (
    <div className="card p-4 mb-4 border-emerald-glow/25">
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-xl bg-emerald-glow/15 flex items-center justify-center text-lg shrink-0">🧭</div>
        <div className="flex-1 min-w-0">
          <div className="text-[11px] text-emerald-glow uppercase tracking-wider font-medium">Путь со Славой</div>
          <div className="text-sm font-medium">Пройден — 21 день</div>
        </div>
      </div>

      <button
        onClick={() => { haptic('light'); nav('/path'); }}
        className="w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl bg-bg-elevated border border-line text-left mb-2 active:scale-[0.99]"
      >
        <BookOpen size={16} className="text-emerald-glow shrink-0" />
        <span className="flex-1 text-sm">Перечитать дни курса</span>
        <ChevronRight size={16} className="text-ink-dim shrink-0" />
      </button>

      <label className="flex items-center justify-between gap-3 px-1 py-1.5 cursor-pointer">
        <span className="text-xs text-ink-muted">Показывать на главной</span>
        <button
          onClick={toggleHome}
          disabled={saving}
          role="switch"
          aria-checked={!!progress.show_on_home}
          className={`w-11 h-6 rounded-full relative transition-colors disabled:opacity-50 ${progress.show_on_home ? 'bg-emerald-glow' : 'bg-line'}`}
        >
          <span className={`absolute top-0.5 w-5 h-5 rounded-full bg-bg transition-all ${progress.show_on_home ? 'left-[22px]' : 'left-0.5'}`} />
        </button>
      </label>
    </div>
  );
}
